module.exports = __webpack_public_path__ + "img/房间露台.5e02f6a9.png";